import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {VisualSizesEnum} from '../../../libs/shared/ui/src/styles/commonStyles';
import {fontWeights} from '../../../libs/shared/ui/src/styles/fontStyles';
import {makeSizeConstants} from '../../../libs/shared/ui/src/styles/styleHelpers';
import {useUserTheme} from '../../../libs/shared/ui/src/theme/userThemeProvider';

const pillSizeStyles = makeSizeConstants(
  `
    font-size: 8px;
    line-height: 7px;
    padding: 2px 4px;
  `,
  `
    font-size: 10px;
    line-height: 9px;
    padding: 3px 6px;
  `,
  `
    font-size: 14px;
    line-height: 13px;
    padding: 5px 10px;
  `,
);

const StyledPill = styled.div<{$backgroundColor: string; $color: string; $size: VisualSizesEnum}>`
  border-radius: 100px;
  display: inline-block;
  font-weight: ${fontWeights.bold};
  background-color: ${(props) => props.$backgroundColor};
  color: ${(props) => props.$color};
  ${(props) => pillSizeStyles[props.$size]}
`;

interface PillProps {
  backgroundColor?: string;
  color?: string;
  size?: VisualSizesEnum;
  className?: string;
}

export const Pill: FC<PropsWithChildren<PillProps>> = ({
  color = 'white',
  size = VisualSizesEnum.SMALL,
  backgroundColor,
  className,
  children,
}) => {
  const theme = useUserTheme();
  return (
    <StyledPill
      $backgroundColor={backgroundColor || theme.palette.yellow.shade40}
      $color={color}
      $size={size}
      className={className}
    >
      {children}
    </StyledPill>
  );
};
